import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Radio = ({
  checked,
  label,
  onClick,
  strong,
  value,
  disabled,
  specialClass,
}) => (
  <div className={`radiobutton ${specialClass}`}>
    <input
      type="radio"
      disabled={disabled}
      checked={checked === value}
    />
    <div className={cn('content-radiobutton', { disabled })}>
      <label onClick={() => onClick(value)} />
      <p
        onClick={() => onClick(value)}
        className={strong ? 'strong' : ''}
      >
        {label}
      </p>
    </div>
  </div>
);

Radio.defaultProps = {
  checked: false,
  strong: false,
  disabled: false,
  specialClass: '',
};

Radio.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  strong: PropTypes.bool,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  specialClass: PropTypes.string,
};

export default Radio;
